import { apiClient } from './apiClient';
const BASE_PATH = '/api/v1/shipments';
/**
 * Get validation items for a shipment
 */
export const getValidationItems = async (shipmentId, params) => {
    const response = await apiClient.get(`${BASE_PATH}/${shipmentId}/validation-items`, { params });
    return response.data;
};
/**
 * Update a validation item
 */
export const updateValidationItem = async (shipmentId, itemId, data) => {
    const response = await apiClient.put(`${BASE_PATH}/${shipmentId}/validation-items/${itemId}`, data);
    return response.data;
};
/**
 * Bulk update validation items
 */
export const bulkUpdateValidationItems = async (shipmentId, data) => {
    const response = await apiClient.post(`${BASE_PATH}/${shipmentId}/validation-items/bulk-update`, data);
    return response.data;
};
